import CreditReportAnalyzer from "../components/CreditReportAnalyzer";
import MobileNav from "../components/MobileNav";

export default function AnalyzeReportPage() {
  return (
    <div className="min-h-screen bg-zinc-950 p-4 md:p-6 lg:p-8">
      <MobileNav />
      <CreditReportAnalyzer 
        isOpen={true} 
        onClose={() => window.history.back()} 
      />
    </div>
  );
}
